export enum StepId {
  LandingPage = 'LANDING_PAGE',
  SelectCategory = 'SELECT_CATEGORY',
  SelectProducts = 'SELECT_PRODUCTS',
  SelectImage = 'SELECT_IMAGE',
  SelectName = 'SELECT_NAME',
  StoreSetup = 'STORE_SETUP',
  StoreReady = 'STORE_READY',
  PrintfulConnection = 'PRINTFUL_CONNECTION',
}

export enum ActionId {
  RedirectToLogin = 'REDIRECT_TO_LOGIN',
  CreateMetaSite = 'CREATE_META_SITE',
  CaptureStoresInstalledAtEntry = 'CAPTURE_STORES_INSTALLED_AT_ENTRY',
  RedirectToConnectPrintful = 'REDIRECT_TO_CONNECT_PRINTFUL',
  RedirectToUpgradePlan = 'REDIRECT_TO_UPGRADE_PLAN',
}
